exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#alertMessage {\n  position: fixed;\n  width: 100%;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n}\n\n#alertMessage .close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /root/production/sne-pro/src/app/component/alert/alert.component.css
// module id = ../../../../../src/app/component/alert/alert.component.css
// module chunks = main